import React, { Dispatch, useCallback } from "react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import styles from "./dropdown-menu.module.scss";

import { ApplicationStore } from "~/app/application.store";
import { switchSearchWrapperAction } from "~/app/chat/search/search.actions";

const DropDownComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const isOpenSearchWrapper: boolean = useSelector((state: ApplicationStore) => state.search.isOpenSearchWrapper);

  const handlePermissionRequest: () => void = () => {
    if ("Notification" in window && Notification.permission !== "denied") {
      void Notification.requestPermission();
    }
  };

  const handleSwitchOpenSearchWrapper: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean): void => {
      dispatch(switchSearchWrapperAction(isOpen));
    },
    [dispatch]
  );

  return (
    <div className={styles.dropDownWrapper}>
      {isOpenSearchWrapper ? (
        <button
          className={classNames(styles.button, styles.buttonBack)}
          onClick={(): void => handleSwitchOpenSearchWrapper(false)}
        >
          <span></span>
        </button>
      ) : (
        <button className={classNames(styles.button, styles.dropDownMenu)} onClick={handlePermissionRequest}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}
    </div>
  );
};

export default DropDownComponent;
